/*
 * <cdx-energy-label-dialog> – one dialog per page for all EU energy label badges.
 * Badges are links to the label image ([data-cdx-energy-label], see snippets/cdx-energylabels.liquid);
 * a normal click shows the image here, modifier clicks still open the link itself.
 * Requires assets/cdx-dialog.js (window.CdxDialog).
 */
if (!customElements.get("cdx-energy-label-dialog") && window.CdxDialog) {
  customElements.define(
    "cdx-energy-label-dialog",
    class CdxEnergyLabelDialog extends window.CdxDialog {
      connectedCallback() {
        super.connectedCallback();
        this.image = this.querySelector(".cdx-energy-label-img");
        this.loading = this.querySelector(".cdx-energy-modal-loading");
        this.status = this.querySelector("[data-energy-label-status]");
        this.loadingText = this.status?.textContent;
      }

      openWithUrl(url, opener) {
        if (!url) return;
        this.loading.hidden = false;
        this.loading.classList.remove("is-error");
        this.status.textContent = this.loadingText;
        this.image.hidden = true;
        this.image.removeAttribute("src");
        this.open(opener);

        // Preload first so the dialog shows the spinner until the label is generated
        const preload = new Image();
        this.preload = preload;
        preload.onload = () => {
          if (this.preload !== preload) return;
          this.image.src = url;
          this.image.hidden = false;
          this.loading.hidden = true;
        };
        preload.onerror = () => {
          if (this.preload !== preload) return;
          this.loading.classList.add("is-error");
          this.status.textContent = this.dataset.errorText || "Fehler beim Laden";
        };
        preload.src = url;
      }

      onClose() {
        super.onClose();
        this.preload = null;
        this.image?.removeAttribute("src");
      }
    }
  );

  document.addEventListener("click", (event) => {
    const badge = event.target.closest("[data-cdx-energy-label]");
    if (!badge || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    const dialog = document.querySelector("cdx-energy-label-dialog");
    if (!dialog?.openWithUrl) return;
    event.preventDefault();
    dialog.openWithUrl(badge.getAttribute("href"), badge);
  });
}
